import React from 'react'
import {capitalize} from '../fn'

export const TextInput = props => {
    return(
        <div className={`${props.children.toLowerCase()} text-input`}>
            <h2>{capitalize(props.children)}</h2>
            <input 
                type="text" 
                value={props.name} 
                onChange={e => props.setValue(e.target.value)} 
                id={props.children.toLowerCase()}
            ></input>
        </div>
    )
}

export const TextAreaInput = props => {
    return(
        <div className={`${props.children.toLowerCase()} text-area-input`}>
            <h2>{capitalize(props.children)}</h2>
            <textarea 
                id={props.children.toLowerCase()}
                value={props.value}
                onChange={e => props.setValue(e.target.value)} 
            >
                
            </textarea>
        </div>
    )
}


